module.exports = __webpack_public_path__ + "static/smi5Mini-28e2bec74e2f5fb506dcc0e1a945f8cc.png";